import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios, { API } from "@/lib/api";
import { toast } from "sonner";

const AuthCallback = ({ onAuth }) => {
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    const handleCallback = async () => {
      if (processing) return;

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');

      if (code) {
        setProcessing(true);
        try {
          const response = await axios.post(`${API}/auth/callback`, { code });
          onAuth(response.data);
          window.history.replaceState({}, document.title, '/auth/callback');
          setTimeout(() => navigate('/', { replace: true }), 100);
        } catch (error) {
          console.error('Auth callback failed:', error);
          if (error.response?.status !== 400 || !error.response?.data?.error?.includes('code')) {
            toast.error('Authentication failed');
          }
          navigate('/', { replace: true });
        }
      } else {
        navigate('/', { replace: true });
      }
    };

    handleCallback();
  }, [onAuth, navigate, processing]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p>Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
